var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
import { LoadStatus, PlayStatus } from '../../learnware/LearnwareEnums';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
export class AspectBackgroundVideo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get answerIntents() {
        if (runtime.isBot)
            return [];
        return this.aspect.context.app.media.mediaPlayer.intents.filter(intent => {
            if (!intent.medFile)
                return false;
            if (intent.medFile.type !== 'vid')
                return false;
            if (this.aspect.context.answer && intent.answerId === this.aspect.context.answer.id)
                return true;
            const { latestFinishedAnswerSincePageload } = this.aspect.context.app.history.historyRecentAnswers;
            if (latestFinishedAnswerSincePageload &&
                latestFinishedAnswerSincePageload.id === intent.answerId &&
                latestFinishedAnswerSincePageload.finishDate.getTime() >= this.aspect.context.app.appClock.clock_250.tickingTime - 2000) {
                return true;
            }
            return false;
        });
    }
    get aspectIntents() {
        const { showPlayingVideo } = this.aspect.valuesOf;
        return this.answerIntents.filter(intent => showPlayingVideo.includes('all') || showPlayingVideo.find(mediumLabel => intent.medFile.mediumLabel.includes(mediumLabel)));
    }
    get renderedIntents() {
        // if (!runtime.availablePackages.Defer) return [];
        if (this.aspect.activesOf.showPlayingVideo.length === 0)
            return [];
        const foreground = this.aspectIntents.filter(intent => [PlayStatus.Go, PlayStatus.Playing, PlayStatus.Paused].includes(intent.playStatus) && intent.loadStatus === LoadStatus.Ready);
        /*
        console.log(
          'renderedIntents',
          [...this.visibleBackgroundsPending, this.visibleBackgroundEnded, ...foreground.concat().reverse()].filter(i => !!i),
        );
    */
        return [...this.visibleBackgroundsPending, this.visibleBackgroundEnded, ...foreground.concat().reverse()].filter(i => !!i);
    }
    get visibleBackgroundsPending() {
        return this.aspectIntents.filter(intent => intent.playStatus === PlayStatus.Pending || (intent.playStatus === PlayStatus.Go && intent.loadStatus === LoadStatus.Loading));
    }
    get visibleBackgroundEnded() {
        return this.aspectIntents.find(intent => [PlayStatus.Ended, PlayStatus.Aborted].includes(intent.playStatus));
    }
}
__decorate([
    computed
], AspectBackgroundVideo.prototype, "aspectIntents", null);
__decorate([
    sortedSet
], AspectBackgroundVideo.prototype, "renderedIntents", null);
__decorate([
    computed
], AspectBackgroundVideo.prototype, "visibleBackgroundsPending", null);
__decorate([
    computed
], AspectBackgroundVideo.prototype, "visibleBackgroundEnded", null);
